(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

$(function () {
  var windowWidth = window.innerWidth;

  if ($('.rect-carousel').length > 0) {
    // Removes the extra uneeded carousel indicators when the page first loads and is between certain widths
    if (windowWidth < 768 && windowWidth > 576) {
      hideShowExtraCarouselIndicators('hide');
    } // Removes the extra uneeded carousel indicators as the window is being resized and the window's width falls between certain widths.


    $(window).on('resize', function () {
      var windowWidth = $(this).width();

      if (windowWidth < 768 && windowWidth > 576) {
        hideShowExtraCarouselIndicators('hide');
      } else if (windowWidth < 577) {
        hideShowExtraCarouselIndicators('show');
      }
    });
  }
  /**
   * This function toggles the visibility of the extra carousel indicators of the rectangular carousel component (see `/car-insurance/car-insurance-for-teens/` carousel as a reference) that appear within certain viewport widths.
   * @param {string} visibility - If `visibility` is set to 'hide', the extra carousel indicators will be hidden. If set to 'show', the extra carousel indicators will be displayed.
   */


  function hideShowExtraCarouselIndicators() {
    var visibility = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'hide';

    if (typeof visibility == 'string' && ['hide', 'show'].includes(visibility.toLowerCase())) {
      var rectCarousels = $('.rect-carousel');

      if (rectCarousels.length > 0) {
        rectCarousels.each(function () {
          var rectCarousel = $(this);
          var carouselIndicators = rectCarousel.find('.carousel-indicators li');
          var visibleCarouselIndicators = carouselIndicators.filter(function () {
            return !$(this).hasClass('d-none');
          }).length;

          if (visibility == 'hide') {
            var requiredCarouselIndicators = Math.ceil(rectCarousel.find('.rect-carousel-tile').length / 2);

            if (visibleCarouselIndicators > requiredCarouselIndicators) {
              carouselIndicators.slice(-(visibleCarouselIndicators - requiredCarouselIndicators)).addClass('d-none');
            }
          } else if (visibility == 'show') {
            var _requiredCarouselIndicators = rectCarousel.find('.rect-carousel-tile').length;

            if (visibleCarouselIndicators < _requiredCarouselIndicators) {
              carouselIndicators.slice(-(visibleCarouselIndicators - _requiredCarouselIndicators)).removeClass('d-none');
            }
          }
        });
      }
    } else {
      console.error("Visibility parameter can only be 'hide' or  'show'.");
    }
  }
});

},{}]},{},[1]);
